import React, { useState, useEffect } from 'react';
import styles from './RawMaterialPage.module.scss';
import productService from '../../services/productService';

// 1. IMPORT HOOK LOADING
import { useLoading } from '../../context/LoadingContext/LoadingContext';

// const BACKEND_URL = 'http://localhost/tramhuong';
const BACKEND_URL = 'https://huongtramcomoc.vn';

const RawMaterialPage = () => {
  const [pageData, setPageData] = useState(null);
  
  // 2. Sử dụng hook loading
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      try {
        showLoading(); // Bật loading
        // Dùng slug 'vung-nguyen-lieu'
        const res = await productService.getPageContent('vung-nguyen-lieu');
        setPageData(res.data);
      } catch (err) {
        console.error("Lỗi tải trang vùng nguyên liệu:", err);
      } finally {
        hideLoading(); // Tắt loading
      }
    };

    fetchData();
  }, []);

  // Nếu chưa có dữ liệu, return null để màn hình trắng (Loading Overlay đang chạy đè lên rồi)
  if (!pageData) return null;

  return (
    <div className={styles.pageContainer}>
      {/* Banner ảnh đại diện (nếu có) */}
      {pageData.featured_image_url && (
        <div className={styles.bannerImage}>
          <img src={`${BACKEND_URL}${pageData.featured_image_url}`} alt={pageData.title} />
           <div className={styles.bannerOverlay}></div>
           <h1 className={styles.pageTitleOnBanner}>{pageData.title}</h1>
        </div>
      )}

      {/* Nếu không có ảnh banner thì hiện tiêu đề màu đen bình thường */}
      {!pageData.featured_image_url && (
         <h1 className={styles.pageTitle}>{pageData.title}</h1>
      )}

      <div 
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: pageData.content }} 
      />
    </div>
  );
};

export default RawMaterialPage;